<template>
    <div v-if="content" class="mt-4 text-info">
        <h2 class="mb-3 text-info-title">{{ content.name }}</h2>
        <div class="text-info-text" v-html="content.text1"></div>
        <div v-if="isArray">
            <h2 class="mb-3 text-info-title"> Dúvidas frequentes </h2>
            <div class="accordion" role="tablist">
                <div class="mb-3" v-for="item in content" :key="item.id">
                    <b-button block v-b-toggle="`accordion-${item.id}`" class="text-left call-center-accordion-btn d-flex justify-content-between align-items-center" @click="idVisible == item.id ? idVisible = null : idVisible = item.id">
                        {{ item.name }}
                        <template v-if="idVisible && idVisible == item.id">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="3">
                                <rect width="500" height="38" fill="#000" class="call-center-accordion-btn-icon"/>
                            </svg>
                        </template>
                        <template v-else>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" class="call-center-accordion-btn-icon">
                                <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/>
                            </svg>
                        </template>
                    </b-button>
                    <b-collapse :id="`accordion-${item.id}`" accordion="my-accordion" role="tabpanel">
                        <b-card class="border-0" body-class="call-center-accordion-text">
                            <div v-html="item.text1"></div>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VBToggle } from 'bootstrap-vue'

export default{
    props:[
        'content',
        'isArray'
    ],
    directives: {
        'b-toggle': VBToggle
    },
    data(){
        return{
            idVisible: null
        }
    }
}
</script>
